import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Frame from '../../components/Frame';
import './index.module.scss';

export default function Home() {
    const dispatch = useDispatch();

    useEffect(() => {
        //window.close();
    }, [dispatch]);

    return (
        <Frame
            title='Closing in 1 second.'
            /*       primaryAction={
                    <Button
                      onClick={() => {
                        pushEvent({ event: 'Create' });
                        history.push('/editor');
                      }}
                    >
                      Add
                    </Button>
                  } */
        >
            <>

            </>
        </Frame>
    );
}
